import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Img from "gatsby-image"
import { Navbar, Nav } from "react-bootstrap";
import DropProductos from "./DropProductos";
import DropPersona from "./DropPersona";
import styled from "styled-components";
import img from "../../../assets/images/icon/quote_icon.png";

import logo from '../../../assets/images/logo.png'
import account from '../../../assets/images/avatar.png'

const Navbaro = ({ landingPage }) => {
	return (
		<Wrapper>
			<Navbar
				expand='lg'
				className={`navbar2 navbar  navbar-expand-lg navbar-light fixed-top`}>
				<div className={`container`}>
					<Navbar.Brand className='mr-auto pl-auto'>
						<Link to='/'>
							<img
								src={logo}
								alt='Baja tu Seguro'
								className=''
								layout='constrained'
								width={180}
							/>
						</Link>
					</Navbar.Brand>
					<Navbar.Toggle
						aria-controls='basic-navbar-nav navbar-toggler btn-close'
						className='offcanvas-header '
					/>
				</div>
				<Navbar.Collapse id='basic-navbar-nav'>
					<Nav as='ul' className='navbar-nav align-items-center'>
						<DropProductos landingPage={landingPage} />
						<Nav.Item as='li'>
							<Link
								to='/contacto'
								className='nav-link'
								activeClassName='active'>
								Contacto
							</Link>
						</Nav.Item>

						<Nav.Item as='li'>
							<Link
								to='/nosotros'
								className='nav-link'
								activeClassName='active'>
								Nosotros
							</Link>
						</Nav.Item>

						<DropPersona landingPage={landingPage} />
						<Nav.Item as='li'>
							<Link to='#' className='nav-link' activeClassName='active'>
								<img
									style={{
										width: "100%",
										maxWidth: 50,
										height: "auto",
									}}
									src={img}
									alt='logo'
								/>
							</Link>
						</Nav.Item>
						<Nav.Item as='li' style={{ width: "186px" }}>
							<Link to='http://67.205.82.108:99/mx/Login' className='nav-link' activeClassName='active'>
								<img
									src={account}
									alt='Cuenta'
									placeholder='blurred'
									width={28}
									className='mr-1'
								/>
								Mi Cuenta
							</Link>
						</Nav.Item>
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		</Wrapper>
	);
};

export default Navbaro;

const Wrapper = styled.header`
	nav {
		height: 72px !important;
		width: 100%;
		background: #fff;
		padding: 5px 20px !important;
		z-index: 999;
		box-shadow: 0px 3px 6px #2f2f2f7b;
	}

	.nav__landingPage {
		justify-content: space-between !important;
		padding: 5px 75px !important;

		.navbar-collapse {
			background: #fff !important;
			flex-basis: unset !important;
		}

		.navbar-nav {
			background: #fff;
			margin-left: auto !important;
		}

		.nav-item {
			margin-left: auto;
		}

		@media (max-width: 768px) {
			padding: 0px !important;
		}

		.nav__landingPage__container {
			@media (max-width: 930px) {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				width: 100%;
				justify-content: space-between;
			}
		}
	}

	.nav-link {
		padding: 0;
		font-size: 16px;
		color: #5268c2 !important;
		font-weight: 600;
		&:hover {
			color: #f89900 !important;
		}
	}

	.nav-item {
		padding: 5px 24px !important;
		text-align: center !important;
	}
	.nav-item:last-child {
		padding: 5px 0 !important;
	}

	.dropdown-menu {
		padding: 20px 30px;
		border: none;
		border-radius: 11px;
		margin-top: 30px;
		box-shadow: 10px 10px 10px #00000029;
		border-radius: 25px;
		> li {
			width: 33.33%;
			display: inline-block;
		}
		h6 {
			color: #3cdbc0;
			font-size: 16px;
		}
		&:after {
			content: "";
			width: 0;
			height: 0;
			position: absolute;
			top: -12px;
			left: 44%;
			border-left: 12px solid transparent;
			border-right: 12px solid transparent;
			border-bottom: 12px solid #fff;
		}
	}

	.dropdown-item {
		padding: 5px 15px 5px 0;
		font-size: 13px;
		&:hover,
		.active {
			background: transparent;
			color: #1a2a6a;
		}
	}

	.dropdown-toggle {
		font-size: 18px;
		font-weight: 600;
		border: none;
		&::after {
			display: none;
		}
	}
	.btn {
		font-size: 16px;
		border-radius: 20px;
	}

	.fa-angle-down {
		font-size: 18px;
		font-weight: 600;
		border: 1px solid red;
	}

	@media only screen and (max-width: 1200px) {
		.nav-item {
			padding: 5px 10px !important;
		}
	}

	@media only screen and (max-width: 991px) {
		.nav-item {
			padding: 8px 10px !important;
			border-bottom: 1px solid #fefefe91 !important;
			width: 90%;
			text-align: center;
		}
		.navbar-nav {
			background: #fff;
			margin: 20px 0 !important;
			.dropdown-menu {
				text-align: center;
				margin-top: 15px;
			}
		}
		.navbar-toggler {
			border: none;
			color: #5268c2;
			padding-right: 0;
			:focus {
				outline: none !important;
				box-shadow: none;
			}
			span {
				font-size: 28px;
				-webkit-text-stroke: 1px #fff;
			}
		}
		.dropdown-menu {
			width: auto;
			box-shadow: none;
			padding: 0;
			> li {
				width: 100%;
				display: block;
			}
		}
	}
	@media (max-width: 767px) {
		.nav-link {
			padding: 5px 10px;
			&:first-child {
				padding-left: 0;
			}
		}
	}
`;
